var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "svg-check-filled",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
    fill: "#0083A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1313 17.202C9.93607 17.3973 9.61949 17.3973 9.42422 17.202L4.57453 12.3523C4.37975 12.1575 4.3792 11.8419 4.57328 11.6465L5.43534 10.7783C5.6304 10.5818 5.94794 10.5813 6.14369 10.777L9.42422 14.0576C9.61949 14.2528 9.93607 14.2528 10.1313 14.0576L17.8563 6.33258C18.0521 6.13683 18.3696 6.13739 18.5647 6.33383L19.4267 7.20201C19.6208 7.39747 19.6202 7.71309 19.4255 7.90786L10.1313 17.202ZM19.7778 2H4.22222C2.98889 2 2 2.98889 2 4.22222V19.7778C2 20.3671 2.23413 20.9324 2.65087 21.3491C3.06762 21.7659 3.63285 22 4.22222 22H19.7778C20.3671 22 20.9324 21.7659 21.3491 21.3491C21.7659 20.9324 22 20.3671 22 19.7778V4.22222C22 2.98889 21 2 19.7778 2Z",
    fill: "#0083A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/checkFilled.fc6af278.svg";
export { ForwardRef as ReactComponent };